import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function Guarantee() {
  return;
}